/* template */
<template><div class="rich-text"><div v-html="html"></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m723effcf"}'>
.rich-text
  max-width 100%
  overflow hidden
  word-break: break-word;
  text-overflow ellipsis
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

import { createComponent } from '@mpxjs/core'
// import { htmlToNodes } from '../../lib/js/util.js'
createComponent({
  properties: {
    html: String,
  },
  data: {
    aliHtml: [],
  },
  // watch: {
  //   'html': function(val) {
  //     if (__mpx_mode__ === 'ali' && val) {
  //       htmlToNodes(val.replace(/<style .*?>(.|\s)*?<\/style>/g, '').replace(/<br>/g, '<br/>')).then(res => {
  //         this.aliHtml = res
  //       })
  //     }
  //   },
  // },
  // attached() {
  //   if (__mpx_mode__ === 'ali' && this.html) {
  //     htmlToNodes(this.html.replace(/<style .*?>(.|\s)*?<\/style>/g, '').replace(/<br>/g, '<br/>')).then(res => {
  //       this.aliHtml = res
  //     })
  //   }
  // },
})


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "component",
    "",
    "rich-text723effcf",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-rich-text':getComponent(require("builtInComponent.vue!=!../../../node_modules/@mpxjs/webpack-plugin/lib/built-in-loader!@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-rich-text.vue?component=true"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
